/** Сервитьор в избора на сервитьор на „Нова маса" (`NewTableWaiterModal`). */
export interface NewTableWaiter {
  id: number;
  name: string;
  openTables: number;
  isMe: boolean;
}

interface WaiterUser {
  id: number;
  names: string | null;
  username: string;
}

const displayName = (user: WaiterUser) => user.names || user.username;

// Служебният акаунт (id 1) не е сервитьор: другите никога не го виждат в
// списъка, а влезъл с него — вижда себе си („Вие“) и всички останали.
const SERVICE_USER_ID = 1;

/**
 * Подредбата в избора на сервитьор на „Нова маса": влезлият най-отгоре, после
 * сервитьорите с неотчетен оборот от най-големия към най-малкия (редът на
 * `GET /bills/waiters-by-turnover`), накрая останалите по азбучен ред.
 * Влезлият влиза и когато го няма в списъка с потребители (напр. собственик
 * с „Всички“ права без роля „Маркиране“). Служебният акаунт (id 1) е само
 * за самия него — за всички други е скрит.
 */
export const orderNewTableWaiters = (
  users: WaiterUser[],
  me: { id: number; name: string },
  turnoverOrder: number[],
  openCountByWaiter: Map<number, number>,
): NewTableWaiter[] => {
  const turnoverRank = new Map(turnoverOrder.map((id, index) => [id, index]));
  const toWaiter = (id: number, name: string): NewTableWaiter => ({
    id,
    name,
    openTables: openCountByWaiter.get(id) ?? 0,
    isMe: id === me.id,
  });
  const myUser = users.find((user) => user.id === me.id);
  const others = users
    .filter((user) => user.id !== me.id && user.id !== SERVICE_USER_ID)
    .map((user) => toWaiter(user.id, displayName(user)))
    .sort((a, b) => {
      const rankA = turnoverRank.get(a.id);
      const rankB = turnoverRank.get(b.id);
      if (rankA !== undefined && rankB !== undefined) return rankA - rankB;
      if (rankA !== undefined) return -1;
      if (rankB !== undefined) return 1;
      return a.name.localeCompare(b.name, "bg");
    });
  return [toWaiter(me.id, myUser ? displayName(myUser) : me.name), ...others];
};
